<script lang="ts" setup>
import IconSvgBase from '~theme/components/atoms/icons/IconSvgBase.vue';
</script>

<template>
  <icon-svg-base :class="$style.path" :view-width="32" :view-height="32">
    <path
      :class="$style.path"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.4155 28.0009C23.2048 28.0009 22.9928 27.9515 22.7982 27.8502L15.9995 24.2982L9.20216 27.8502C8.7515 28.0835 8.2075 28.0435 7.7995 27.7449C7.38883 27.4462 7.18483 26.9409 7.2715 26.4409L8.56616 18.9369L3.07283 13.6235C2.7075 13.2702 2.5755 12.7395 2.7315 12.2542C2.8875 11.7715 3.30483 11.4182 3.80883 11.3462L11.4088 10.2422L14.8062 3.40754C15.2568 2.50087 16.7435 2.50087 17.1942 3.40754L20.5915 10.2422L28.1915 11.3462C28.6955 11.4182 29.1128 11.7715 29.2688 12.2542C29.4248 12.7395 29.2928 13.2702 28.9275 13.6235L23.4342 18.9369L24.7288 26.4409C24.8155 26.9409 24.6102 27.4462 24.2008 27.7449C23.9688 27.9155 23.6928 28.0009 23.4155 28.0009"
    />
  </icon-svg-base>
</template>

<style lang="scss" module>
.path {
  width: 1em;
  height: 1em;
  stroke: currentColor;
}
</style>
